import * as React from "react";

const WhatsappIconSvg = ({ size = 20, color = "#851D1E", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 1.66669C5.4 1.66669 1.66667 5.40002 1.66667 10C1.66667 11.3834 2.01667 12.6834 2.63333 13.8167L1.66667 18.3334L6.26667 17.3834C7.36667 17.95 8.65 18.2667 10 18.2667C14.6 18.2667 18.3333 14.5334 18.3333 9.93335C18.3333 5.33335 14.6 1.66669 10 1.66669Z"
      fill={color}
    />
    <path
      d="M13.8833 12.35C13.65 12.8334 12.6167 13.4167 12.15 13.5C11.75 13.5667 11.25 13.5834 10.7167 13.4167C10.3833 13.3167 10 13.1834 9.56667 13C8.21667 12.4167 7.13333 11.05 7.03333 10.9334C6.93333 10.8167 6.16667 9.81669 6.16667 8.76669C6.16667 7.71669 6.71667 7.21669 6.91667 6.96669C7.08333 6.76669 7.36667 6.71669 7.58333 6.71669C7.66667 6.71669 7.73333 6.71669 7.81667 6.71669C7.96667 6.71669 8.08333 6.75002 8.18333 6.98335C8.31667 7.30002 8.66667 8.21669 8.71667 8.33335C8.76667 8.45002 8.81667 8.60002 8.73333 8.76669C8.66667 8.93335 8.6 9.01669 8.48333 9.15002C8.36667 9.28335 8.25 9.41669 8.15 9.51669C8.01667 9.65002 7.88333 9.80002 8.03333 10.05C8.18333 10.3 8.66667 11.0834 9.41667 11.6834C10.35 12.4334 11.1333 12.6834 11.3833 12.7834C11.6333 12.8834 11.7833 12.8667 11.9333 12.7167C12.0833 12.5667 12.55 12.05 12.7167 11.8167C12.8833 11.5834 13.05 11.6167 13.25 11.7C13.45 11.7834 14.55 12.3167 14.7833 12.4167C15.0167 12.5167 15.1833 12.5667 15.2333 12.65C15.3 12.7667 15.3 13.2834 13.8833 12.35Z"
      fill="#fff"
    />
  </svg>
);

export default WhatsappIconSvg;
